import PickerView from 'antd-mobile/lib/picker-view';
export default PickerView;



// WEBPACK FOOTER //
// ./components/picker-view/index.tsx